module.exports = __webpack_public_path__ + "static/img/account-refresh.37c9d03a.svg";